<div class="dash-card">
    <div class="dash-card-header d-block">
        <div class="row">
            <div class="col-8">
                <h2>{{companyData.corporate_name}}</h2>
            </div>
            <div class="col-4 text-right">
                <app-button (onClick)="toggleUserModal()" class="add-button"
                    *ngIf="permissionObj.canAdd">
                    <svg-icon src="assets/images/icon-add.svg"
                        class="mr-2"></svg-icon>
                    Adicionar usuário
                </app-button>
            </div>
        </div>
        <app-spacer [bottom]="16"></app-spacer>

        <div class="d-flex align-items-center">
            {{companyData.document_number}}
            <app-spacer [right]="16"></app-spacer>

            <svg-icon src="assets/images/icon-check-filled.svg"
                fill="var(--success)"
                *ngIf="companyData.status === 'active'"></svg-icon>
            <app-spacer [right]="8"></app-spacer>
            {{companyData.statusDisplay}}
        </div>
        <app-spacer [bottom]="16"></app-spacer>

        <p>
            Gerencie os acessos desta empresa, incluindo usuários, departamentos
            e permissões.
        </p>
    </div>
</div>
<app-spacer [bottom]="48"></app-spacer>

<div class="dash">
    <!-- Tabs modernas -->
    <div class="dashboard-tabs-container">
        <div class="dashboard-tabs">
            <button type="button" class="dashboard-tab" *ngFor="let tab of tabs"
                [class.active]="activeTab === tab.value"
                (click)="onTabChange(tab.value)">
                {{tab.label}}
            </button>
        </div>
    </div>
    <app-spacer [bottom]="16"></app-spacer>

    <div [class.d-none]="activeTab !== 'departments'">
        <app-dashboard-companies-details-departments
            [companyId]="authService.user?.active_register?.register?.company?.id"
            [activeTab]="activeTab"></app-dashboard-companies-details-departments>
    </div>

    <div [class.d-none]="activeTab !== 'users'">
        <app-dashboard-company-users
            [activeTab]="activeTab"></app-dashboard-company-users>
    </div>
</div>

<app-side-modal [active]="showUserModal" title="Adicionar Usuário"
    (onClose)="showUserModal = false">
    <form [formGroup]="form">
        <div class="row">
            <!-- ETAPA 1: Tipo de usuário e CPF -->
            <div class="col-12">
                <p>Tipo de usuário</p>
                <app-spacer [bottom]="16"></app-spacer>

                <div class="d-flex">
                    <app-radio [multiple]="true"
                        (onCheckChanged)="handleChangeValue('simple')"
                        [isChecked]="isSimple">
                        <div class="flex-1 d-flex flex-column">
                            <span class="pep-title">Usuário comum</span>
                        </div>
                    </app-radio>
                    <app-spacer [right]="24"></app-spacer>

                    <ng-container>
                        <app-radio [multiple]="true"
                            (onCheckChanged)="handleChangeValue('master')"
                            [isChecked]="isMaster">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title">Usuário master</span>
                            </div>
                        </app-radio>
                    </ng-container>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-masked-input [group]="form" controlName="document"
                    label="CPF" mask="000.000.000-00" [isDocument]="true"
                    placeholder="Digite o CPF">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <!-- Loading enquanto valida documento -->
            <div class="col-12 text-center" *ngIf="checkingDocument">
                <p style="color: var(--dark); font-size: var(--font-sm);">
                    <svg-icon src="assets/images/icon-loading.svg"></svg-icon>
                    Verificando
                    documento...
                </p>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <!-- ETAPA 2: Resto do formulário (aparece SOMENTE se documentExists === FALSE) -->
            <ng-container *ngIf="!documentExists && !checkingDocument">
                <!-- Campos comuns a ambos os tipos - APARECEM PRIMEIRO -->
                <div class="col-12">
                    <app-input [group]="form" controlName="name"
                        label="Nome completo" placeholder="Digite">
                    </app-input>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12">
                    <app-input [group]="form" controlName="email" label="E-mail"
                        placeholder="Digite">
                    </app-input>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Campos para Usuário Comum - APARECEM DEPOIS -->
                <div class="col-12" *ngIf="!isMaster">
                    <app-select [items]="departmentOptions" [group]="form"
                        controlName="department" placeholder="Selecione"
                        label="Departamento">
                    </app-select>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Removido: campo de perfil de acesso não é mais necessário para usuário comum -->
            </ng-container>

        </div>

        <app-spacer [bottom]="64"></app-spacer>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="handleCloseModal()" class="add-button"
                    [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="submit()" [disabled]="getDisabled()"
                        class="add-button">
                        Adicionar usuário
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>

<app-loading-spinner [active]="addingUser"></app-loading-spinner>